/*
 * Mobile Thumbnail Auto-Hide with Counter Badge
 * Thumbnails show for 3 seconds, then collapse to a "1/3" counter.
 * Re-expands on swipe (slide change) or tap on the counter.
 *
 * THEME UPDATE NOTE:
 * If theme is updated, re-add this line to layout/theme.liquid in <head>,
 * between variant-image-filter.js and theme.js:
 *   <script src="{{ 'mobile-thumb-autohide.js' | asset_url }}" defer="defer"></script>
 */

(function() {
  'use strict';

  var AUTOHIDE_DELAY = 3000;
  var MOBILE_MAX = 768;

  document.addEventListener('DOMContentLoaded', function() {
    var thumbContainer = document.querySelector('[data-product-thumbs]');
    var slideshow = document.querySelector('[data-product-photos]');
    if (!thumbContainer || !slideshow) return;

    // Don't activate on single-image products
    var visibleThumbs = thumbContainer.querySelectorAll('.product__thumb-item:not(.hide)');
    if (visibleThumbs.length < 2) return;

    // Create counter badge
    var counter = document.createElement('div');
    counter.className = 'product__thumb-counter';
    counter.textContent = '1/' + visibleThumbs.length;
    thumbContainer.appendChild(counter);

    var timer = null;
    var lastSelectedClass = '';

    function isMobile() {
      return window.innerWidth <= MOBILE_MAX;
    }

    function updateCounter() {
      var visible = thumbContainer.querySelectorAll('.product__thumb-item:not(.hide)');
      var currentIndex = 0;
      visible.forEach(function(thumb, i) {
        if (thumb.querySelector('a.is-active')) currentIndex = i;
      });
      counter.textContent = (currentIndex + 1) + '/' + visible.length;
    }

    function showThumbnails() {
      if (!isMobile()) return;
      clearTimeout(timer);
      thumbContainer.classList.remove('thumbs-collapsed');
      timer = setTimeout(hideThumbnails, AUTOHIDE_DELAY);
    }

    function hideThumbnails() {
      if (!isMobile()) return;
      updateCounter();
      thumbContainer.classList.add('thumbs-collapsed');
    }

    // Tap counter to expand
    counter.addEventListener('click', function(e) {
      e.stopPropagation();
      showThumbnails();
    });

    // Detect slide changes via MutationObserver
    // subtree: true is critical — Flickity wraps slides in .flickity-slider (grandchildren)
    // childList: true catches Flickity destroy/recreate on variant changes
    var debounceTimer = null;
    var observer = new MutationObserver(function(mutations) {
      if (!isMobile()) return;

      var slideChanged = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        // Class change on a slide element
        if (m.type === 'attributes' && m.attributeName === 'class' &&
            m.target.classList && m.target.classList.contains('is-selected') &&
            m.target.classList.contains('product-main-slide')) {
          slideChanged = true;
          break;
        }
        // Flickity rebuild (childList changes)
        if (m.type === 'childList' && m.addedNodes.length > 0) {
          slideChanged = true;
          break;
        }
      }

      if (slideChanged) {
        // Debounce to avoid rapid triggers during Flickity animations
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          updateCounter();
          showThumbnails();
        }, 50);
      }
    });

    observer.observe(slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
      childList: true
    });

    // Resize handler — always registered
    var resizeTimer = null;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (!isMobile()) {
          // Desktop: always show thumbnails, no counter
          clearTimeout(timer);
          thumbContainer.classList.remove('thumbs-collapsed');
        } else if (!thumbContainer.classList.contains('thumbs-collapsed')) {
          // Just resized to mobile: start autohide timer
          clearTimeout(timer);
          timer = setTimeout(hideThumbnails, AUTOHIDE_DELAY);
        }
      }, 150);
    });

    // Initial: start 3-second timer on mobile
    if (isMobile()) {
      timer = setTimeout(hideThumbnails, AUTOHIDE_DELAY);
    }
  });
})();
